import { SortDescriptor } from "react-aria-components";

import { AiIntegrationView } from "shared/AiIntegration/useSearchAiIntegrations/gql";

export const sortIntegrations = (
  integrations: AiIntegrationView[],
  sortDescriptor: SortDescriptor
): AiIntegrationView[] => {
  const { column, direction } = sortDescriptor;

  return [...integrations].sort((a, b) => {
    let compareValue;

    switch (column) {
      case "name":
        compareValue = a.name.localeCompare(b.name);
        break;
      case "provider":
        compareValue = a.provider.localeCompare(b.provider);
        break;
      case "model":
        compareValue = a.modelDetails
          .map((model) => model.name)
          .join(",")
          .localeCompare(b.modelDetails.map((model) => model.name).join(","));
        break;
      case "space":
        compareValue = (a.space?.name ?? "").localeCompare(b.space?.name ?? "");
        break;
      case "status":
        compareValue = Number(a.enabled) - Number(b.enabled);
        break;
      case undefined:
      default:
        return 0;
    }

    return direction === "ascending" ? compareValue : -compareValue;
  });
};
